import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"
import { CiEdit } from "react-icons/ci";
import { MdOutlinePreview } from "react-icons/md";
import { FaTrash, FaList, FaProjectDiagram } from "react-icons/fa";
import {API} from '../../../Services/axios'
import {URLS} from '../../../Services/Urls';
import { FaPlus } from "react-icons/fa";
import { ImPlus } from "react-icons/im";
import { toast } from 'react-toastify';
import useSWR from 'swr';
import axios from 'axios';
import DemandesList from './DemandesList';

const BeProjects = () => {

  const [projectsTab, setProjectsTab] = useState([]);
  const [activeTab, setActiveTab] = useState('projects'); // 'projects' ou 'demandes'
  
    // const key = 'https://rullier.api.ova-consulting.fr/api/be/admin/projets'
    // const key = 'http://192.168.100.12:8000/api/be/admin/projets/'
    
    // const fetcher = url => axios.get(url).then(res => res.data).catch(err => {
    //   console.error("Error in fetcher:", err);
    //   throw err;
    // });
    // const { data: projects, error, isLoading: loadingProjects} = useSWR(key, fetcher)
    // const projectsArray = projects?.results;
  
    // if (error) {
    //   return <div className='mt-5'>Error loading projects</div>;
    // }
    // if (loadingProjects) {
    //   return <div className='mt-5'>Loading...</div>;
    // }
    // if (!projects) {
    //   return <div className='mt-5'>No projects</div>
    // }
  
    // console.log("Fetching projects from:", key);

    useEffect(() => {
      API.get(URLS.BE.PROJECT.create)
          .then((resp) => {
            setProjectsTab(resp.data.results);
            console.log('Projects:', resp.data.results);
          })
          .catch((error) => {
            toast.error(error?.response?.data?.detail)
          })
    }, []);

    const handleDeleteProject = (projectId, event) => {
      event.preventDefault(); // Empêche la navigation si le bouton est dans un Link
      if (window.confirm("Êtes-vous sûr de vouloir supprimer ce projet ? Cette action est irréversible.")) {
        API.delete(URLS.BE.PROJECT.delete(projectId))
          .then(() => {
            toast.success("Projet supprimé avec succès !");
            setProjectsTab(projectsTab.filter(p => p.id !== projectId));
          })
          .catch(error => {
            toast.error(error?.response?.data?.detail || "Erreur lors de la suppression du projet.");
          });
      }
    };

    return(
        <>
            <div className="content-body">
                  <div className="container-fluid">
                    {/* Onglets de navigation */}
                    <div className="row mb-4">
                      <div className="col-12">
                        <ul className="nav nav-tabs" id="beTabs" role="tablist">
                          <li className="nav-item" role="presentation">
                            <button
                              className={`nav-link ${activeTab === 'projects' ? 'active' : ''}`}
                              onClick={() => setActiveTab('projects')}
                              type="button"
                            >
                              <FaProjectDiagram className="me-2" />
                              Projets du Bureau d'Étude
                            </button>
                          </li>
                          <li className="nav-item" role="presentation">
                            <button
                              className={`nav-link ${activeTab === 'demandes' ? 'active' : ''}`}
                              onClick={() => setActiveTab('demandes')}
                              type="button"
                            >
                              <FaList className="me-2" />
                              Demandes
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>

                    {/* Contenu des onglets */}
                    {activeTab === 'projects' && (
                      <div className="row">
                      {/* {projectsArray.map(p => (
                        <div className="col-md-3 col-sm-4 col-12">
                          <div className=''>
                            <div className="card p-0 project-card">
                              <img src="https://blog.neowood.fr/hubfs/Imported_Blog_Media/bois-bardage-2-2.jpg" alt="" />
                              <div className="project-card-slide p-2">
                                <p className="projet px-4">[Projet]</p>
                                <p className="projet-name px-4">{p.name}</p>
                                <div className="project-utils">
                                  <div className="d-flex">
                                    <Link to={`/projet/${p.id}`} className='edit-link me-2'> 
                                      <span className="d-flex">
                                        <span className='m-auto'><MdOutlinePreview /></span>
                                        <span className='ms-1'>Apercu</span>
                                      </span>
                                    </Link>
                                    
                                    <Link to={`/projet/${p.id}`} className='edit-link'>
                                      <span className="d-flex">
                                        <span className='m-auto'><CiEdit /></span>
                                        <span className='ms-1'>Modifier</span>
                                      </span>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))} */}

                      {projectsTab.map(p => (
                        <div className="col-md-3 col-sm-4 col-12">
                          <div className=''>
                            <div className="card p-0 project-card" style={{height: '200px', overflow: 'hidden'}}>
                              <img loading="lazy" src={p.image} alt={p.nom} style={{height: '100%', width: 'auto'}} />
                              <div className="project-card-slide p-2">
                                <p className="projet px-4">[Projet]</p>
                                <p className="projet-name px-4">{p.nom}</p>
                                <div className="project-utils">
                                  <div className="d-flex">
                                    <button onClick={(e) => handleDeleteProject(p.id, e)} className='btn btn-danger btn-sm delete-link me-2 h-50'> 
                                      <span className="d-flex">
                                        <span className='m-auto'><FaTrash /></span>
                                        <span className='ms-1'>Supprimer</span>
                                      </span>
                                    </button>
                                    
                                    <Link to={`/select-project/${p.id}`} className='btn btn-sm edit-link' style={{backgroundColor: '#4CAF50'}}>
                                    {/* <Link to={`/select-project/${p.id}`} className='btn btn-sm edit-link' style={{backgroundColor: '#B39C81'}}> */}
                                      <span className="d-flex">
                                        <span className='m-auto'><CiEdit /></span>
                                        <span className='ms-1'>Modifier</span>
                                      </span>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                      
                      {/* // <div className="col-md-3 col-sm-4 col-12">
                      //   <div className=''>
                      //     <div className="card p-0 project-card">
                      //       <img src="https://blog.neowood.fr/hubfs/Imported_Blog_Media/bois-bardage-2-2.jpg" alt="" />
                      //       <div className="project-card-slide p-2">
                      //         <p className="projet px-4">[Projet]</p>
                      //         <p className="projet-name px-4">Bardage et terasse</p>
                      //         <div className="project-utils">
                      //           <div className="d-flex">
                      //             <Link to={"projects/23/edit"} className='edit-link me-2'> 
                      //               <span className="d-flex">
                      //                 <span className='m-auto'><MdOutlinePreview />
                      //                 </span>
                      //                 <span className='ms-1'>Apercu</span>
                      //               </span>
                      //             </Link>
                      //             <Link to={"projects/23/edit"} className='edit-link'> 
                      //               <span className="d-flex">
                      //                 <span className='m-auto'><CiEdit /></span>
                      //                 <span className='ms-1'>Modifier</span>
                      //               </span>
                      //             </Link>
                      //           </div>
                      //         </div>
                      //       </div>
                      //     </div>
                      //   </div>
                      // </div>
                      // <div className="col-md-3 col-sm-4 col-12">
                      //   <div className=''>
                      //     <div className="card p-0 project-card">
                      //       <img src="https://blog.neowood.fr/hubfs/Imported_Blog_Media/bois-bardage-2-2.jpg" alt="" />
                      //       <div className="project-card-slide p-2">
                      //         <p className="projet px-4">[Projet]</p>
                      //         <p className="projet-name px-4">Bardage et terasse</p>
                      //         <div className="project-utils">
                      //           <div className="d-flex">
                      //             <Link to={"projects/23/edit"} className='edit-link me-2'> 
                      //               <span className="d-flex">
                      //                 <span className='m-auto'><MdOutlinePreview />
                      //                 </span>
                      //                 <span className='ms-1'>Apercu</span>
                      //               </span>
                      //             </Link>
                      //             <Link to={"projects/23/edit"} className='edit-link'> 
                      //               <span className="d-flex">
                      //                 <span className='m-auto'><CiEdit /></span>
                      //                 <span className='ms-1'>Modifier</span>
                      //               </span>
                      //             </Link>
                      //           </div>
                      //         </div>
                      //       </div>
                      //     </div>
                      //   </div>
                      // </div> */}
                      <div className="col-md-3 col-sm-4 col-12">
                        <div className='card p-0 project-card rounded-2 d-flex align-items-center justify-content-center' style={{height: '200px'}}>
                          <Link to={'/select-project'} className="h-100 w-100 d-flex align-items-center justify-content-center text-decoration-none">
                            <ImPlus size={40} color="grey"/>
                          </Link>
                        </div>
                      </div>
                      </div>
                    )}

                    {/* Onglet des demandes */}
                    {activeTab === 'demandes' && (
                      <DemandesList />
                    )}
                  </div>
                </div>
        </>
    )

}

export default BeProjects;